export default __webpack_public_path__ + "static/media/03.dcb6b013.jpg";